<template>
  <a-card  class="card-class"  >
    <a-button type="primary" @click="loadData()">刷新</a-button>
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      :scroll="{x:true}"
    >
      <template slot="izActivity" slot-scope="text">
        <span v-if="text === 1" class="green">启用</span>
        <span v-if="text === 0" class="red">禁用</span>
      </template>
      <!-- <a-popconfirm
        title="确定删除吗?"
        @confirm="() => handleDelete(record)"
        slot="action"
        slot-scope="text, record"
      >
        <a>删除</a>
      </a-popconfirm> -->
      <span slot="action" slot-scope="text, record">
              <a @click="editAppServerRelation(record.id)">应用配置</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
    </a-table>
    <BusServermanageAppServers ref="BusServermanageAppServers"></BusServermanageAppServers>
  </a-card>
</template>

<script>
import {getServerListByAppId} from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { deleteByServerAppId } from '@/api/api.js'
import BusServermanageAppServers from '.././modules/BusServermanageAppServers.vue'
export default {
  components: {
    BusServermanageAppServers
  },
  mixins: [JeecgListMixin],
  props: {
    appId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dataSource: [],
      loading:false,
      /* 分页参数 */
        ipagination: {
          current: 1,
          pageSize: 999,
        },
        /* 排序参数 */
        isorter: {
          column: 'sort',
          order: 'asc',
        },
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
          title: 'ip地址',
          align: 'center',
          dataIndex: 'ip',
        },
        {
          title: '系统类型',
          align: 'center',
          dataIndex: 'sysType',
        },
        {
          title: '启用',
          align: 'center',
          dataIndex: 'izActivity',
          scopedSlots: {
            customRender: 'izActivity',
          },
        },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.dataSource = []
      var params = this.getQueryParams()
      // 服务id获取应用列表
        params.appId=this.appId
        getServerListByAppId(params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
        } else {
          this.$message.warning(res.message)
        }
      }).finally(()=>{
        this.loading = false
      })
      
    },
    handleDelete(record){
      // 删除服务器和应用的关系
        deleteByServerAppId({serverId:record.id,appId:this.appId}).then((res) => {
        if (res.success) {
          this.$message.success("删除成功")
          this.loadData();
        } else {
          this.$message.warning(res.message)
        }
      })
      .finally(() => {
        this.loading = false
      })

    },
    editAppServerRelation(serverId){
      this.$refs.BusServermanageAppServers.open(this.appId,serverId);
    }
  },
  watch: {
    appId(newValue, oldValue) {
      this.loadData()
    },
  },
}
</script>

<style lang="less" scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.card-class{
  min-height: 900px;
}
</style>